import React from 'react'
import './styles.scss'
// import Scrollchor from 'react-scrollchor'
import styled from 'styled-components'
// import Data from './data-FootnotesBox.js'

export default class chart extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: false,
    }
    this.toggleMore = this.toggleMore.bind(this)
    this.trackMoreClick = this.trackMoreClick.bind(this)
    this.trackLessClick = this.trackLessClick.bind(this)
  }

  // trackMoreClick (targetLink) {
  //   // GA tracking
  //   let clickedPerson = targetLink.getAttribute('data-person')
  //   console.log('person:' + clickedPerson)
  //   window.dataLayer = window.dataLayer || []
  //   window.dataLayer.push({
  //     event: 'Interactions',
  //     event_action: 'click',
  //     event_label: 'Porträt: ' + clickedPerson
  //   })
  // }

  trackMoreClick(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Toggle: ' + clickedText,
    })
  }

  trackLessClick(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Toggle: ' + clickedText,
    })
  }

  toggleMore() {
    if (this.state.isExpanded) {
      this.setState({
        isExpanded: false,
        fade: false,
      })
    } else {
      // GA tracking
      // let clickedPerson = e.currentTarget.getAttribute('data-person')
      // console.log('person:' + clickedPerson)
      // window.dataLayer = window.dataLayer || []
      // window.dataLayer.push({
      //   event: 'Interactions',
      //   event_action: 'click',
      //   event_label: 'Porträt: ' + clickedPerson
      // })
      this.setState({
        isExpanded: true,
        fade: true,
      })
    }
  }

  render() {
    return (
      <>
        <Methodology className={this.props.colorMode}>
          <div
            className={
              this.state.isExpanded
                ? 'chart-info expanded'
                : 'chart-info collapsed'
            }
          >
            <div className='intro-text'>
              <h3>{this.props.language[0].title}</h3>
              <div className='text'>{this.props.language[0].text}</div>
              <br />

              {this.props.language[0].listItem.map((item, index) => {
                if (index <= 1) {
                  return (
                 
                      <li key={index}>
                        <b>{item.title}</b>:&nbsp;{item.text}
                      </li>
 
                  )
                } else if (index === 2) {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className={this.state.fade ? 'notDisplay' : 'fade'}
                        id='mehrLesen'
                        
                      >
                        <li>
                          <b>{item.title}</b>:&nbsp;{item.text}
                        </li>
                      </div>
                      <div className='show-more'>
                        <Button
                          className='ui button toggleText'
                          onClick={() => {
                            this.toggleMore()
                            this.trackMoreClick('mehrLesen')
                          }}
                          data-person={this.props.trackingID}
                        >
                          {this.props.tenant?.lang === 'de' ? 'Mehr ' : 'Plus ' }
                          <svg
                            width='24px'
                            height='24px'
                            viewBox='0 0 24 24'
                            version='1.1'
                            xmlns='http://www.w3.org/2000/svg'
                            className='iconArrow'
                          >
                            <title>1 Element/Icon/Arrow Down</title>
                            <g
                              id='1-Element/Icon/Arrow-Down'
                              stroke='none'
                              strokeWidth='1'
                              fill='none'
                              fillRule='evenodd'
                            >
                              <g id='Icon/Arrow-Right'>
                                <rect
                                  id='Size'
                                  x='0'
                                  y='0'
                                  width='24'
                                  height='24'
                                ></rect>
                              </g>
                              <polygon
                                id='Path'
                                fill='var(--text-color)'
                                points='17.8994949 10.4142136 12.9497475 15.363961 8 10.4142136 9.41421356 9 12.9497475 12.5355339 16.4852814 9'
                              ></polygon>
                            </g>
                          </svg>
                        </Button>
                      </div>
                    </React.Fragment>
                  )
                }
              })}
              <div className='additional-text'>
                <>
                  <ul>
                    {this.props.language[0].listItem.map((item, index) => {
                      if (index >= 3) {
                        return (
                          <li key={index}>
                            <b>{item.title}</b>:&nbsp;{item.text}
                          </li>
                        )
                      }
                    })}
                  </ul>
                </>
              </div>

              <div className='show-less'>
                <a
                  href='#mehrLesen'
                  className='ui button toggleText'
                  onClick={() => {
                    this.toggleMore()
                    this.trackLessClick('weniger')
                  }}
                  animate={{ offset: -15 }}
                >
                  {this.props.tenant?.lang === 'de' ? 'Weniger ' : 'Moins ' }
                  <svg
                    width='24px'
                    height='24px'
                    viewBox='0 0 24 24'
                    version='1.1'
                    xmlns='http://www.w3.org/2000/svg'
                    className='iconArrow'
                  >
                    <title>1 Element/Icon/Arrow Up</title>
                    <g
                      id='1-Element/Icon/Arrow-Up'
                      stroke='none'
                      strokeWidth='1'
                      fill='none'
                      fillRule='evenodd'
                    >
                      <g id='Icon/Arrow-Right'>
                        <rect
                          id='Size'
                          x='0'
                          y='0'
                          width='24'
                          height='24'
                        ></rect>
                      </g>
                      <polygon
                        id='Path'
                        fill='var(--text-color)'
                        points='17.8994949 13.9497475 12.9497475 9 8 13.9497475 9.41421356 15.363961 12.9497475 11.8284271 16.4852814 15.363961'
                      ></polygon>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </Methodology>
      </>
    )
  }
}

const Button = styled.div`
  cursor: pointer;
`

const Methodology = styled.div`
  font-family: var(--font-plex);
  color: var(--text-color);
  padding: 1em 1.5em;
  font-size: 0.9em;
  line-height: 2.7rem;
  margin-bottom: 4em;
  margin: 0em 0em 4em 0em;
  border-radius: 0.5em;
  border: 1px solid var(--brandblue-bright-5);
  &.dark {
    box-shadow: 0 3px 12px rgba(255, 255, 255, 0.063);
    border: 1px solid var(--gray-2);
  }
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.053);
  /* box-shadow: 0px 4.5px 1.3px rgba(0, 0, 0, 0.03),
    0px 8.6px 3.1px rgba(0, 0, 0, 0.035), 0px 12.7px 5.5px rgba(0, 0, 0, 0.037),
    0px 17.3px 9.2px rgba(0, 0, 0, 0.038), 0px 23.4px 15.1px rgba(0, 0, 0, 0.04),
    0px 33.5px 26.4px rgba(0, 0, 0, 0.047), 0px 60px 57px rgba(0, 0, 0, 0.07); */
  h3 {
    /* border-top: 1px solid var(--red-main); */
    padding-top: 0.25em;
    font-size: 1.2em;
    margin-top: 0.25em;
    text-align: center;
    border-bottom: 1px solid #c8c8d1;
    padding-bottom: 0.5em;
  }
  ul {
    line-height: 1.7em;
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
  }
  ul > li {
    list-style: none;
    padding-bottom: 1em;
    font-size: 0.9em;
    line-height: 1.55em;
  }

  ul > li::before {
    display: block;
    width: 2rem;
    border-bottom: 1px solid #c8c8d1;
    content: '';
    margin-bottom: 0.5em;
  }
  .text {
    line-height: 1.5em;
  }
  div {
    li {
      list-style: none;
      padding-bottom: 1em;
      font-size: 0.9em;
      line-height: 1.55em;
    }
    li::before {
      display: block;
      width: 2rem;
      border-bottom: 1px solid #c8c8d1;
      content: '';
      margin-bottom: 0.5em;
    }
  }
`
